module.exports = __webpack_public_path__ + "assets/6a6154b7776a04330577d7fb581c94f7.png";